export interface StoreConfig {
  siteId: number;
  name: string;
  logoUrl: string;
  storefrontUrl: string;
  sortOrder: number;
}

export const STORES: StoreConfig[] = [
  {
    siteId: 1,
    name: 'Honey Willow Consignment',
    logoUrl: '/logos/honey-willow.png',
    storefrontUrl:
      import.meta.env.VITE_HONEYWILLOW_STORE_URL ||
      'https://new.honeywillowconsignment.com',
    sortOrder: 1,
  },
  {
    siteId: 2,
    name: 'Modern Maven Consignment',
    logoUrl: '/logos/modern-maven.png',
    storefrontUrl:
      import.meta.env.VITE_MODERNMAVEN_STORE_URL ||
      'https://new.modernmavenshop.ca',
    sortOrder: 2,
  },
  {
    siteId: 3,
    name: 'Offboarded',
    logoUrl:
      import.meta.env.VITE_OFFBOARDED_LOGO_URL ||
      '/logos/offboarded.svg',
    storefrontUrl:
      import.meta.env.VITE_OFFBOARDED_STORE_URL ||
      'https://offboarded.ca',
    sortOrder: 3,
  },
];

export function getStoreBySiteId(siteId: number): StoreConfig | undefined {
  return STORES.find((s) => s.siteId === siteId);
}

export function productUrl(siteId: number, sku: string): string {
  const store = getStoreBySiteId(siteId);
  const base = store?.storefrontUrl || STORES[0].storefrontUrl;
  return `${base.replace(/\/$/, '')}/product/${encodeURIComponent(sku)}`;
}
